import { useEffect, useState } from "react";
import { PagingType, QueryParam } from "../api";
import { eventApi } from "../api/event.service";

export interface EventQuery extends QueryParam {}

interface UseEventProps {
  initQuery: EventQuery;
}

export const useEvent = ({ initQuery }: UseEventProps) => {
  const [data, setData] = useState<any[]>([]);
  const [query, setQuery] = useState<EventQuery>(initQuery);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await eventApi.findAll(query);

      setData(data?.data);
    } catch (error: any) {
      console.log("Get event list failed:", error);

      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  return { data, fetchData, loading, error, setQuery, query };
};
